import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/vender/myProducts";

export default class VendorProductsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	// toggleStatus = (id, data) => {
	// 	return http.put(`${apiStatusEndpoint}/${id}`, data);
	// };
}
